(function () {
  function initProductSection(root) {
    var sectionId = root.getAttribute('data-section-id');
    if (!sectionId) return;
    var cfgEl = document.getElementById('ProductConfig-' + sectionId);
    var cfg = {};
    if (cfgEl) { try { cfg = JSON.parse(cfgEl.textContent); } catch (e) {} }
    var section = root;
    var byId = function (id) { return document.getElementById(id + '-' + sectionId); };

    // Thumbnail click -> swap main image
    var thumbs = section.querySelectorAll('.product-custom__thumb');
    var mainImg = section.querySelector('[id^="MainImage-"]');
    if (thumbs.length && mainImg) {
      thumbs.forEach(function (btn) {
        btn.addEventListener('click', function () {
          mainImg.src = btn.dataset.mediaSrc;
          if (btn.dataset.mediaSrcset) mainImg.srcset = btn.dataset.mediaSrcset;
          mainImg.alt = btn.dataset.mediaAlt || '';
          mainImg.setAttribute('data-media-id', btn.dataset.mediaId);
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          btn.classList.add('is-active');
        });
      });
    }

    // Quantity +/- buttons
    section.querySelectorAll('.product-custom__qty').forEach(function (wrap) {
      var input = wrap.querySelector('.product-custom__qty-input');
      wrap.querySelectorAll('.product-custom__qty-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          if (btn.dataset.action === 'decrease') val = Math.max(1, val - 1);
          else val = val + 1;
          input.value = val;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });

    // Sticky bar
    var stickyBar = byId('StickyAtc');
    var originalAtc = section.querySelector('.product-custom__atc-btn');
    var stickyInnerAtc = byId('StickyInnerAtc');
    var stickyInnerNotify = byId('StickyInnerNotify');
    var notifyWrapEl = byId('NotifyForm');

    if (stickyBar) {
      var stickyTargets = [originalAtc, notifyWrapEl].filter(Boolean);
      var stickyVisibility = {};
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyVisibility[entry.target.id || 'atc'] = entry.isIntersecting;
        });
        var anyVisible = Object.values(stickyVisibility).some(function (v) { return v; });
        stickyBar.classList.toggle('is-visible', !anyVisible);
      }, { threshold: 0 });
      stickyTargets.forEach(function (el) { observer.observe(el); });

      var stickyAtcBtn = byId('StickyAtcBtn');
      var stickyLabel = byId('sticky-label');
      var cartVariantIds = new Set();
      var atcLabelText = cfg.atcLabel || '';

      var updateStickyCartState = function () {
        if (!stickyAtcBtn || !stickyLabel) return;
        var hiddenId = section.querySelector('input[name="id"]');
        var currentId = hiddenId ? parseInt(hiddenId.value, 10) : null;
        var inCart = currentId && cartVariantIds.has(currentId);
        stickyAtcBtn.classList.toggle('product-custom__sticky-btn--in-cart', inCart);
        stickyLabel.textContent = inCart ? '✓ Dans le panier · Rajouter' : atcLabelText;
      };

      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        cart.items.forEach(function (i) { cartVariantIds.add(i.variant_id); });
        updateStickyCartState();
      }).catch(function () {});

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
          if (event.cartData && event.cartData.items) {
            cartVariantIds = new Set(event.cartData.items.map(function (i) { return i.variant_id; }));
          }
          updateStickyCartState();
        });
      }
      if (stickyAtcBtn && originalAtc) {
        stickyAtcBtn.addEventListener('click', function () { originalAtc.click(); });
      }
      root._updateStickyCartState = updateStickyCartState;
    }

    // Back-in-stock notify
    var notifyWrap = byId('NotifyForm');
    var notifyForm = notifyWrap ? notifyWrap.querySelector('.product-custom__notify-form') : null;
    var atcRow = section.querySelector('.product-custom__atc-row');
    var dynamicCheckout = section.querySelector('.product-custom__dynamic-checkout');
    var oosOverlay = byId('OosOverlay');
    var oosOverlayMobile = byId('OosOverlayMobile');

    // localStorage BIS (product-custom only, via cfg.bisEnabled + cfg.handle)
    if (cfg.bisEnabled && cfg.handle && notifyWrap) {
      var bisAlreadyNotified = false;
      try { bisAlreadyNotified = !!localStorage.getItem('bis_notify_' + cfg.handle); } catch (e) {}
      if (bisAlreadyNotified) {
        var nTop = notifyWrap.querySelector('.product-custom__notify-top:not(.product-custom__notify-registered)');
        var nFormEl = notifyWrap.querySelector('.product-custom__notify-form');
        var nRegistered = byId('NotifyRegistered');
        if (nTop) nTop.classList.add('hidden');
        if (nFormEl) nFormEl.classList.add('hidden');
        if (nRegistered) nRegistered.classList.remove('hidden');
        var sRow = byId('StickyNotifyRow');
        var sSucc = byId('StickyNotifySuccess');
        if (sRow) sRow.classList.add('hidden');
        if (sSucc) sSucc.classList.remove('hidden');
      }
    }

    var stickyNotifyBtn = byId('StickyNotifyBtn');
    if (stickyNotifyBtn && notifyForm) {
      stickyNotifyBtn.addEventListener('click', function () {
        var stickyEmail = byId('StickyNotifyEmail');
        if (!stickyEmail || !stickyEmail.value.trim()) return;
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(stickyEmail.value.trim())) return;
        var mainEmail = byId('NotifyEmail');
        if (mainEmail) mainEmail.value = stickyEmail.value.trim();
        notifyForm.submit();
      });
    }

    // Lightbox
    var lightbox = byId('ProductLightbox');
    if (lightbox) document.body.appendChild(lightbox);
    var lightboxImg = lightbox ? lightbox.querySelector('.product-custom__lightbox-img') : null;
    var lightboxCurrent = lightbox ? lightbox.querySelector('.product-custom__lightbox-current') : null;
    var lightboxTotal = lightbox ? lightbox.querySelector('.product-custom__lightbox-total') : null;
    var lightboxPrev = lightbox ? lightbox.querySelector('.product-custom__lightbox-arrow--prev') : null;
    var lightboxNext = lightbox ? lightbox.querySelector('.product-custom__lightbox-arrow--next') : null;
    var lightboxDataEl = byId('LightboxData');
    var lightboxImages = [];
    if (lightboxDataEl) { try { lightboxImages = JSON.parse(lightboxDataEl.textContent); } catch (e) {} }
    var lightboxIndex = 0;

    function lightboxShow(index) {
      if (!lightbox || !lightboxImages.length) return;
      lightboxIndex = index;
      lightboxImg.src = lightboxImages[index].src;
      lightboxImg.alt = lightboxImages[index].alt;
      if (lightboxCurrent) lightboxCurrent.textContent = index + 1;
      if (lightboxTotal) lightboxTotal.textContent = lightboxImages.length;
      lightbox.setAttribute('aria-hidden', 'false');
      lightbox.style.opacity = '1';
      lightbox.style.visibility = 'visible';
      document.body.classList.add('lightbox-open');
      document.body.style.overflow = 'hidden';
      if (lightboxPrev) lightboxPrev.style.display = lightboxImages.length <= 1 ? 'none' : '';
      if (lightboxNext) lightboxNext.style.display = lightboxImages.length <= 1 ? 'none' : '';
      if (lightboxTotal && lightboxCurrent) {
        lightboxTotal.parentElement.style.display = lightboxImages.length <= 1 ? 'none' : '';
      }
    }
    function lightboxHide() {
      if (!lightbox) return;
      lightbox.setAttribute('aria-hidden', 'true');
      lightbox.style.opacity = '0';
      lightbox.style.visibility = 'hidden';
      document.body.classList.remove('lightbox-open');
      document.body.style.overflow = '';
    }
    function lightboxNav(dir) {
      if (!lightboxImages.length) return;
      lightboxIndex = (lightboxIndex + dir + lightboxImages.length) % lightboxImages.length;
      lightboxImg.src = lightboxImages[lightboxIndex].src;
      lightboxImg.alt = lightboxImages[lightboxIndex].alt;
      if (lightboxCurrent) lightboxCurrent.textContent = lightboxIndex + 1;
    }
    if (lightbox) {
      var mainImgEl = section.querySelector('.product-custom__main-image img[id^="MainImage-"]');
      if (mainImgEl) {
        mainImgEl.addEventListener('click', function () {
          var mediaId = String(mainImgEl.getAttribute('data-media-id'));
          var idx = 0;
          for (var i = 0; i < lightboxImages.length; i++) {
            if (String(lightboxImages[i].id) === mediaId) { idx = i; break; }
          }
          lightboxShow(idx);
        });
      }
      lightbox.addEventListener('click', function (e) {
        if (!e.target.closest('.product-custom__lightbox-img, .product-custom__lightbox-arrow')) lightboxHide();
      });
      if (lightboxPrev) lightboxPrev.addEventListener('click', function () { lightboxNav(-1); });
      if (lightboxNext) lightboxNext.addEventListener('click', function () { lightboxNav(1); });
      document.addEventListener('keydown', function (e) {
        if (lightbox.getAttribute('aria-hidden') !== 'false') return;
        if (e.key === 'Escape') lightboxHide();
        if (e.key === 'ArrowLeft') lightboxNav(-1);
        if (e.key === 'ArrowRight') lightboxNav(1);
      });
      var touchStartX = 0, touchStartY = 0;
      lightbox.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
      }, { passive: true });
      lightbox.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].screenX - touchStartX;
        var dy = e.changedTouches[0].screenY - touchStartY;
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 50) lightboxNav(dx < 0 ? 1 : -1);
      }, { passive: true });
    }

    // Variant change -> toggle ATC vs Notify
    var variantData = cfg.variants || [];
    document.addEventListener('change', function () {
      setTimeout(function () {
        var hiddenId = section.querySelector('input[name="id"]');
        if (!hiddenId) return;
        var selectedId = parseInt(hiddenId.value, 10);
        var variant = variantData.find(function (v) { return v.id === selectedId; });
        if (!variant) return;
        var stickyBtnPrice = byId('sticky-price');
        if (stickyBtnPrice && typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          stickyBtnPrice.textContent = Shopify.formatMoney(variant.price);
        }
        var stickyVariant = byId('sticky-variant');
        if (stickyVariant) stickyVariant.textContent = variant.title;
        if (root._updateStickyCartState) root._updateStickyCartState();

        if (variant.available) {
          if (atcRow) atcRow.classList.remove('hidden');
          if (dynamicCheckout) dynamicCheckout.classList.remove('hidden');
          if (notifyWrap) notifyWrap.classList.add('hidden');
          if (oosOverlay) oosOverlay.classList.add('hidden');
          if (oosOverlayMobile) oosOverlayMobile.classList.add('hidden');
          if (stickyInnerAtc) stickyInnerAtc.classList.remove('hidden');
          if (stickyInnerNotify) stickyInnerNotify.classList.add('hidden');
        } else {
          if (atcRow) atcRow.classList.add('hidden');
          if (dynamicCheckout) dynamicCheckout.classList.add('hidden');
          if (oosOverlay) oosOverlay.classList.remove('hidden');
          if (oosOverlayMobile) oosOverlayMobile.classList.remove('hidden');
          if (notifyWrap) notifyWrap.classList.remove('hidden');
          var tagsInput = byId('NotifyTags');
          if (tagsInput && cfg.notifyTag != null) {
            tagsInput.value = cfg.notifyTag;
          }
          if (tagsInput && cfg.notifyTagPrefix != null) {
            tagsInput.value = cfg.notifyTagPrefix + variant.id;
          }
          var noteInput = byId('NotifyNote');
          if (noteInput && cfg.notifyNotePrefix != null) {
            noteInput.value = cfg.notifyNotePrefix + variant.id;
          }
          if (stickyInnerAtc) stickyInnerAtc.classList.add('hidden');
          if (stickyInnerNotify) {
            stickyInnerNotify.classList.remove('hidden');
            var sRow2 = byId('StickyNotifyRow');
            var sSucc2 = byId('StickyNotifySuccess');
            var sBtn2 = byId('StickyNotifyBtn');
            var sEmail2 = byId('StickyNotifyEmail');
            if (sRow2) sRow2.classList.remove('hidden');
            if (sSucc2) sSucc2.classList.add('hidden');
            if (sBtn2) { sBtn2.disabled = false; var sp = sBtn2.querySelector('span'); if (sp) sp.textContent = "M'avertir"; }
            if (sEmail2) sEmail2.value = '';
          }
        }
      }, 50);
    });
  }

  function initAll() {
    document.querySelectorAll('.product-custom[data-section-id]').forEach(initProductSection);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
